import request from '@/util/request';
import qs from 'qs';

/* 供应商管理 - 分页接口 */
export const getPageListApi = (params, options) =>
  request.get('/api/nursing/partner/page', Object.assign({}, options, { params }));

/* 供应商管理 - 新增 */
export const addApi = (params, options) =>
  request.post('/api/nursing/partner/save', params, options, { ContentType: 'application/json' });

/* 供应商管理 - 修改 */
export const updateApi = (params, options) =>
  request.post('/api/nursing/partner/update', params, options, {
    ContentType: 'application/json',
  });

/* 供应商管理 - 删除 */
export const removeApi = (params, options) =>
  request.post('/api/nursing/partner/remove', qs.stringify(params), options);
